<template>
	<layout-page max-screen-height="true" title="Negotiation & Settlement">
		<div class="max-h-full md:overflow-hidden flex-grow flex flex-col">
			<div
				class="sticky top-[0rem] md:static bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start"
			>
				<h1 class="truncate text-3xl md:text-4xl font-semibold text-white">
					{{ __("Negotiation") }} &amp; {{ __("Settlement") }}
				</h1>
			</div>
			<thread-overview
				class="md:overflow-hidden flex flex-col flex-grow"
				:initial-statuses="statuses"
				v-bind:initial-active-id="activeId"
			/>
		</div>
	</layout-page>
</template>

<script>
export default {
	props: {
		activeId: {
			type: Number,
			required: false,
			default: null,
		},
		statuses: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
};
</script>
